module.exports = __webpack_public_path__ + "static/media/49.6dbdeee3.jpg";